import { useField } from 'informed';
import { RichTextEditorInput } from 'components/common/richTextEditor';

import type { Editor } from '@tiptap/core';

interface Props
  extends Omit<
    React.ComponentProps<typeof RichTextEditorInput>,
    'initialValue' | 'onChange'
  > {
  id?: string;
  field: string;
  initialValue?: string;
  onFocus?: (editor: Editor) => void;
  onValueChange?: (html: string) => Promise<void> | void;
  validate?: (value: any, values?: any) => undefined | string;
  validateOnChange?: boolean;
}

const RichText = (props: Props) => {
  const { onFocus, ...otherProps } = props;
  const { fieldApi, fieldState, render, userProps } = useField({
    ...otherProps
  });

  const updateHTML = (html: string) => {
    fieldApi.setValue(html);
    if (userProps.onValueChange) userProps.onValueChange(html);
  };

  return render(
    <RichTextEditorInput
      {...userProps}
      error={fieldState.error}
      onFocus={onFocus}
      onChange={updateHTML}
      value={fieldState.value || userProps.initialValue || ''}
      valueUpdateTimeout={0}
    />
  );
};

export default RichText;
